import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import ValidationText from "../../utils/validation/ValidationText.js";
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import moment from 'moment';
import { encryptionAPI } from '../../utils/Encryption.js';
import { APIURL } from '../../utils/AppSetting.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { GenerateProformaInvoice } from '../../services/axioServices/ApiEndPoints.js';
import HSNCodeTable from '../../components/despatch/GSTInvoiceFinishGoods/HSNCodeTable.js';

class SalesOrderEntry extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            isEditing: false,
            isLoading: false,
            tableStatus: "",
            isGridView: true,
            isMaterialDetailsHide: true,
            filterDetails: {
                partyName: "",
                arrangedBy: "",
            },
            orderDetails: {
                salesOrderId: "",
                partyId: "",
                orderDate: "",
                remarks: "",
            },
            itemDetails: {
                itemMappingId: "",
                itemName: "",
                itemId: "",
                hsnCodeId: "",
                hsnCodeName: "",
                quantity: "",
                free: "",
                mrp: "",
                rate: "",
                amount: "",
            },
            partyDropdownList: [],
            itemDropdownList: [],
            itemDetailsArray: [],
            salesOrderEntryList: [],
            // FG-invoice-style live GST computation for the proforma preview
            hsnCodeList: [],            // HSN master with rates
            companyItemMap: {},         // itemId -> { HSNCode, UOM, Packing }
            selectedPartyState: "",     // to decide IGST vs CGST/SGST
            computedItemListing: [],    // per-item taxable + GST for display
            hsnCodeListForTable: [],    // grouped HSN breakup
            proformaTotals: {
                subTotalTaxable: 0, discount: 0, sgst: 0, cgst: 0, igst: 0,
                subTotalInclGst: 0, freight: 0, freightInclGst: 0, roundOff: 0,
                grandTotal: 0, advance: 0, balance: 0,
            },
            // Proforma Invoice (advance-payment document) — generate-only, nothing saved
            isProformaLoading: false,
            proformaDetails: {
                transportName: "",
                freight: "",
                discount: "",
                advance: "",
                deliveryDate: "",
                dueDate: "",
            },
            arrangedByList: [
                { arrangedBy: "Date", value: "orderDate" },
                { arrangedBy: "Party Name", value: "partyName" },

            ],
            validationRules: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                orderDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "order date"
                        ),
                    },
                ],
            },
            validationRulesItemDetailsFields: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                mrp: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "mrp"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validStateItemDetailsFields: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllSalesOrderEntry();
    }

    getAllSalesOrderEntry = () => {
        this.setState({ tableStatus: "Loading..." }, () => {
            let request = this.state.filterDetails
            this.despatchServices.getAllSalesOrderEntry(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    let res = response.responseData;
                    this.setState({ salesOrderEntryList: res }, () => {
                        this.getAllPartyDropdown()
                    });
                } else {
                    this.setState({ tableStatus: "" })
                    this.getAllPartyDropdown()
                    this.SwalServices.Error(response.Message);
                }
            });
        })
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    state: item.state,
                    transporterName: item.transporterName,
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllItem();

                });
            } else {
                this.getAllItem();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllItem = () => {
        this.commonServices.getAllItem().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.ItemName,
                    value: item._id,
                }));
                // itemId -> master details (HSN code / unit) used for the proforma GST
                let companyItemMap = {};
                res.forEach((item) => {
                    companyItemMap[item._id] = {
                        HSNCode: item.HSNCode || "",
                        UOM: item.UOM || "",
                        Packing: item.Packing || "",
                    };
                });
                this.setState({ itemDropdownList: dropdownItems, companyItemMap: companyItemMap }, () => {
                    this.getAllHSNCode();
                });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllHSNCode = () => {
        this.commonServices.getAllHSNCode().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let hsnCodeList = response.responseData.map((item) => ({
                    label: item.HSNCode,
                    value: item._id,
                    sgstRate: item.SGST,
                    cgstRate: item.CGST,
                    igstRate: item.IGST,
                    utgstRate: item.UTGST,
                }));
                this.setState({ hsnCodeList: hsnCodeList });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    // Live proforma computation (mirrors the backend generateProformaInvoice exactly)
    computeProformaTotals = () => {
        const items = this.state.itemDetailsArray || [];
        const hsnList = this.state.hsnCodeList || [];
        const itemMap = this.state.companyItemMap || {};
        const isInter = (this.state.selectedPartyState || "") !== "GUJARAT";
        const freight = Number(this.state.proformaDetails.freight) || 0;
        const discount = Number(this.state.proformaDetails.discount) || 0;
        const advance = Number(this.state.proformaDetails.advance) || 0;

        const rawSubTotal = items.reduce(
            (s, it) => s + (Number(it.amount) || (Number(it.quantity) * Number(it.rate))), 0
        );

        const computed = items.map((it) => {
            const itemAmount = Number(it.amount) || (Number(it.quantity) * Number(it.rate));
            const itemDiscount = rawSubTotal > 0 ? (itemAmount / rawSubTotal) * discount : 0;
            const taxable = Number((itemAmount - itemDiscount).toFixed(2));
            const itemId = it.itemId && it.itemId._id ? it.itemId._id : it.itemId;
            // prefer the HSN chosen on the item; fall back to the item master's HSN
            const hsnId = it.hsnCodeId && it.hsnCodeId._id ? it.hsnCodeId._id : it.hsnCodeId;
            let hsn = hsnId ? hsnList.find((h) => String(h.value) === String(hsnId)) : null;
            if (!hsn) {
                const masterCode = (itemMap[itemId] && itemMap[itemId].HSNCode) || "";
                hsn = hsnList.find((h) => String(h.label) === String(masterCode));
            }
            hsn = hsn || {};
            const hsnCode = hsn.label || "";
            const sgstRate = isInter ? 0 : (Number(hsn.sgstRate) || 0);
            const cgstRate = isInter ? 0 : (Number(hsn.cgstRate) || 0);
            const igstRate = isInter ? (Number(hsn.igstRate) || 0) : 0;
            const gstRate = sgstRate + cgstRate + igstRate;
            const gstAmount = Number((taxable * gstRate / 100).toFixed(2));
            return { ...it, hsnCode, taxable, gstRate, gstAmount, sgstRate, cgstRate, igstRate };
        });

        // group by HSN code for the breakup table
        const groups = {};
        computed.forEach((c) => {
            const key = c.hsnCode || "-";
            if (!groups[key]) {
                groups[key] = { label: c.hsnCode || "-", taxableAmount: 0, sgstRate: c.sgstRate, cgstRate: c.cgstRate, igstRate: c.igstRate, utgstRate: 0 };
            }
            groups[key].taxableAmount += c.taxable;
        });
        const hsnCodeListForTable = Object.values(groups).map((g) => {
            const sgstAmount = Number((g.taxableAmount * (g.sgstRate || 0) / 100).toFixed(2));
            const cgstAmount = Number((g.taxableAmount * (g.cgstRate || 0) / 100).toFixed(2));
            const igstAmount = Number((g.taxableAmount * (g.igstRate || 0) / 100).toFixed(2));
            return {
                ...g,
                taxableAmount: Number(g.taxableAmount.toFixed(2)),
                sgstAmount, cgstAmount, igstAmount, utgstAmount: 0,
                totalAmount: Number((g.taxableAmount + sgstAmount + cgstAmount + igstAmount).toFixed(2)),
            };
        });

        const subTotalTaxable = computed.reduce((s, c) => s + c.taxable, 0);
        const sgst = hsnCodeListForTable.reduce((s, h) => s + h.sgstAmount, 0);
        const cgst = hsnCodeListForTable.reduce((s, h) => s + h.cgstAmount, 0);
        const igst = hsnCodeListForTable.reduce((s, h) => s + h.igstAmount, 0);
        const itemGstTotal = sgst + cgst + igst;
        const subTotalInclGst = Number((subTotalTaxable + itemGstTotal).toFixed(2));
        // Freight is a plain charge — NO GST is applied on it.
        const freightInclGst = Number(freight.toFixed(2));
        const preRound = subTotalInclGst + freightInclGst;
        const grandTotal = Math.round(preRound);
        const roundOff = Number((grandTotal - preRound).toFixed(2));
        const balance = Number((grandTotal - advance).toFixed(2));

        this.setState({
            computedItemListing: computed,
            hsnCodeListForTable: hsnCodeListForTable,
            proformaTotals: {
                subTotalTaxable: Number(subTotalTaxable.toFixed(2)),
                discount: Number(discount.toFixed(2)),
                sgst: Number(sgst.toFixed(2)), cgst: Number(cgst.toFixed(2)), igst: Number(igst.toFixed(2)),
                subTotalInclGst, freight: Number(freight.toFixed(2)), freightInclGst, roundOff, grandTotal,
                advance: Number(advance.toFixed(2)), balance,
            },
        });
    };

    addEditSalesOrderEntry = () => {
        let isValidAllItemDetailsFields = this.isValidAllItemDetailsFields();
        if (isValidAllItemDetailsFields) {
            this.setState({ isLoading: true }, () => {
                let orderDetails = this.state.orderDetails
                let itemDetails = this.state.itemDetails

                if (orderDetails.salesOrderId === "") {
                    delete orderDetails.salesOrderId;
                }

                if (itemDetails.itemMappingId === "") {
                    delete itemDetails.itemMappingId;
                }

                // empty HSN must be null (an ObjectId ref cannot be an empty string)
                if (!itemDetails.hsnCodeId || itemDetails.hsnCodeId === "") {
                    itemDetails.hsnCodeId = null;
                }

                let request = {
                    orderDetails: orderDetails,
                    itemDetails: itemDetails
                }

                this.despatchServices.addEditSalesOrderEntry(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let details = this.state.orderDetails
                        details.salesOrderId = response.responseData.orderDetails._id
                        this.setState({ orderDetails: details }, () => {
                            this.getAllOrderDetailsItemMappingById(this.state.orderDetails)
                        })
                        this.setState({ isLoading: false })
                        this.SwalServices.Success(response.Message)
                    } else {
                        this.setState({ isLoading: false })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    resetOrderDetils = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let details = this.state.orderDetails
        details.salesOrderId = ''
        details.orderDate = ''
        details.partyId = ''
        details.remarks = ''
        this.setState({ orderDetails: details, validState: validState })
    }

    // Clears the whole entry (party + items + computed proforma state) so a new
    // entry always starts blank and never inherits a previously opened order.
    resetEntryData = (callback) => {
        this.setState({
            orderDetails: { salesOrderId: "", partyId: "", orderDate: "", remarks: "" },
            itemDetails: { itemMappingId: "", itemName: "", itemId: "", hsnCodeId: "", hsnCodeName: "", quantity: "", free: "", mrp: "", rate: "", amount: "" },
            itemDetailsArray: [],
            computedItemListing: [],
            hsnCodeListForTable: [],
            proformaTotals: {
                subTotalTaxable: 0, discount: 0, sgst: 0, cgst: 0, igst: 0,
                subTotalInclGst: 0, freight: 0, freightInclGst: 0, roundOff: 0,
                grandTotal: 0, advance: 0, balance: 0,
            },
            proformaDetails: { transportName: "", freight: "", discount: "", advance: "", deliveryDate: "", dueDate: "" },
            selectedPartyState: "",
            isEditing: false,
            isMaterialDetailsHide: true,
            validState: { isValid: true, error: {} },
            validStateItemDetailsFields: { isValid: true, error: {} },
        }, callback);
    }

    resetItemDetails = () => {
        let validState = this.state.validStateItemDetailsFields
        validState.isValid = true
        validState.error = {}
        let details = this.state.itemDetails
        details.itemMappingId = ""
        details.itemName = ""
        details.itemId = ""
        details.hsnCodeId = ""
        details.hsnCodeName = ""
        details.quantity = ""
        details.free = ""
        details.mrp = ""
        details.rate = ""
        details.amount = ""
        this.setState({ itemDetails: details, validStateItemDetailsFields: validState, isEditing: false })
    }

    isValidAllItemDetailsFields = () => {
        const newValidState = isValidForm(
            this.state.itemDetails,
            this.state.validationRulesItemDetailsFields,
            this.state.validStateItemDetailsFields
        );
        this.setState({ validStateItemDetailsFields: newValidState });
        return newValidState.isValid
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.orderDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        if (newValidState.isValid) {
            this.setState({ isMaterialDetailsHide: false })
        } else {
            this.setState({ isMaterialDetailsHide: true })
        }
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true });
    };

    closeGridView = () => {
        // Start a brand-new entry with a fully clean slate (no leftover order/items).
        this.resetEntryData(() => {
            this.setState({ isGridView: false });
        });
    };

    resetForm = () => {
        let filterDetails = this.state.filterDetails;
        filterDetails.partyName = "";
        filterDetails.arrangedBy = "";
        this.resetEntryData();
        this.setState({ filterDetails: filterDetails }, () => {
            this.getAllSalesOrderEntry()
        });
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllSalesOrderEntry()
            });
        } else if (section === "orderDetails") {
            let details = this.state.orderDetails;
            details[name] = value.toUpperCase();
            this.setState({ orderDetails: details }, () => {
                this.isValidAllFields()
            });
        } else if (section === 'ItemDetails') {
            let details = this.state.itemDetails
            details[name] = value.toUpperCase();
            if (name === 'rate' || name === 'quantity') {
                details.amount = (Number(details.quantity) * Number(details.rate)).toFixed(2)
            }
            this.setState({ itemDetails: details })
        }
    };

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details }, () => {
            this.getAllSalesOrderEntry()
        });
    };

    setFilterParameters = (selected, drpIdentity, section) => {
        if (section === 'ItemDetails') {
            let details = this.state.itemDetails
            details[drpIdentity] = selected.value
            if (drpIdentity === 'itemId') {
                // auto-fill the HSN from the item master (user can still change it)
                let hsnCode = (this.state.companyItemMap[selected.value] && this.state.companyItemMap[selected.value].HSNCode) || "";
                let hsn = this.state.hsnCodeList.find((h) => String(h.label) === String(hsnCode));
                details.hsnCodeId = hsn ? hsn.value : "";
                details.hsnCodeName = hsn ? hsn.label : "";
            }
            if (drpIdentity === 'hsnCodeId') {
                details.hsnCodeName = selected.label;
            }
            this.setState({ itemDetails: details })
        } else {
            let details = this.state.orderDetails;
            details[drpIdentity] = selected.value;
            let extra = {};
            if (drpIdentity === 'partyId') {
                extra.selectedPartyState = selected.state || "";
                // pre-fill transport from the party master (like the GST invoice does)
                let pd = this.state.proformaDetails;
                if (selected.transporterName) { pd.transportName = selected.transporterName; }
                extra.proformaDetails = pd;
            }
            this.setState({ orderDetails: details, ...extra }, () => {
                this.isValidAllFields()
                this.computeProformaTotals()
            });
        }
    }

    getAllOrderDetailsItemMappingById = (orderDetails) => {
        let details = this.state.orderDetails
        details.orderDate = moment(orderDetails.orderDate).format('yyyy-MM-DD')
        details.partyId = orderDetails.partyId._id ? orderDetails.partyId._id : orderDetails.partyId
        details.remarks = orderDetails.remarks
        details.salesOrderId = orderDetails.salesOrderId ? orderDetails.salesOrderId : orderDetails._id
        // resolve the party's state for the proforma GST (IGST vs CGST/SGST)
        let selectedParty = this.state.partyDropdownList.find((p) => p.value === details.partyId);
        let selectedPartyState = selectedParty ? (selectedParty.state || "") : "";
        // When opening from the list, the row carries the saved charges -> load them.
        // When re-called after adding/deleting an item (from state, no charge keys),
        // keep whatever charges are already on screen so they are not wiped.
        let openingFromList = orderDetails.freight !== undefined;
        let loadedProforma = openingFromList
            ? {
                transportName: orderDetails.transportName || (selectedParty ? (selectedParty.transporterName || "") : ""),
                deliveryDate: orderDetails.deliveryDate || "",
                dueDate: orderDetails.dueDate || "",
                freight: orderDetails.freight ? orderDetails.freight : "",
                discount: orderDetails.discount ? orderDetails.discount : "",
                advance: orderDetails.advance ? orderDetails.advance : "",
            }
            : this.state.proformaDetails;
        this.setState({ orderDetails: details, selectedPartyState: selectedPartyState, proformaDetails: loadedProforma }, () => {
            this.despatchServices.getAllOrderDetailsItemMappingById(this.state.orderDetails.salesOrderId).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    let details = response.responseData;
                    this.setState({ itemDetailsArray: details }, () => {
                        this.isValidAllFields()
                        this.resetItemDetails()
                        this.setState({ isGridView: false })
                        this.computeProformaTotals()
                    })
                } else {
                    this.SwalServices.Error(response.Message);
                }
            });
        })
    }

    editItemDetails = (item) => {
        let details = this.state.itemDetails
        details.itemId = item.itemId._id
        let hsnId = item.hsnCodeId && item.hsnCodeId._id ? item.hsnCodeId._id : item.hsnCodeId;
        let hsn = this.state.hsnCodeList.find((h) => String(h.value) === String(hsnId));
        details.hsnCodeId = hsn ? hsn.value : "";
        details.hsnCodeName = hsn ? hsn.label : "";
        details.quantity = item.quantity
        details.free = item.free
        details.mrp = item.mrp
        details.rate = item.rate
        details.amount = item.amount
        details.itemMappingId = item._id
        this.setState({ itemDetails: details, isEditing: true })
    }

    deleteSalesOrderById = (id) => {
        this.despatchServices.deleteSalesOrderById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.getAllSalesOrderEntry()
                this.SwalServices.Success(response.Message);
            } else {
                this.SwalServices.Error(response.Message);
            }
        })
    }

    deleteSalesOrderItemByItemId = (id) => {
        this.despatchServices.deleteSalesOrderItemByItemId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.getAllOrderDetailsItemMappingById(this.state.orderDetails)
                this.SwalServices.Success(response.Message);
            } else {
                this.SwalServices.Error(response.Message);
            }
        })
    }

    // ---- Proforma Invoice (advance-payment document) ----
    handleProformaChange = (event, name) => {
        let details = this.state.proformaDetails;
        details[name] = event.target.value;
        this.setState({ proformaDetails: details }, () => {
            // freight / discount / advance affect the live totals
            this.computeProformaTotals();
        });
    }

    // Persist the proforma charges on the order so they are still there when it is reopened.
    saveProformaDetails = () => {
        if (!this.state.orderDetails.salesOrderId) return;
        let request = {
            salesOrderId: this.state.orderDetails.salesOrderId,
            transportName: this.state.proformaDetails.transportName,
            deliveryDate: this.state.proformaDetails.deliveryDate,
            dueDate: this.state.proformaDetails.dueDate,
            freight: this.state.proformaDetails.freight,
            discount: this.state.proformaDetails.discount,
            advance: this.state.proformaDetails.advance,
        };
        this.despatchServices.updateSalesOrderProforma(request).then(() => { }).catch(() => { });
    }

    generateProformaInvoice = () => {
        this.saveProformaDetails();
        this.setState({ isProformaLoading: true }, () => {
            let loginUser = getAuthProps();
            let headers = {
                Authorization: `Bearer ${loginUser.token}`,
                dbYear: loginUser.dbYear,
            };
            let payload = {
                salesOrderId: this.state.orderDetails.salesOrderId,
                transportName: this.state.proformaDetails.transportName,
                freight: this.state.proformaDetails.freight,
                discount: this.state.proformaDetails.discount,
                advance: this.state.proformaDetails.advance,
                deliveryDate: this.state.proformaDetails.deliveryDate,
                dueDate: this.state.proformaDetails.dueDate,
            };
            let encryptId = encryptionAPI(payload, 1);
            fetch(`${APIURL + GenerateProformaInvoice}?id=${encryptId}`, {
                method: 'GET',
                headers: headers,
            })
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isProformaLoading: false });
                })
                .catch(() => {
                    this.setState({ isProformaLoading: false });
                    this.SwalServices.Error("Unable to generate proforma invoice.");
                });
        });
    }

    render() {
        return (
            <div className='salesOrderEntry-page'>
                {/* First page  */}
                {this.state.isGridView === true ? (
                    <>
                        {/* 1. Item Search  */}
                        <div className="item-search">
                            <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                                <div className="search-grp w-[60%]">
                                    <label>Party Name</label>
                                    <input
                                        type="text"
                                        id="partyName"
                                        name="partyName"
                                        className="inputFocus w-full"
                                        autocomplete="off"
                                        value={this.state.filterDetails.partyName}
                                        onChange={(event) =>
                                            this.handleChange(event, "partyName", "filterDetails")
                                        }
                                    />
                                </div>

                                <div className="search-grp w-[40%]">
                                    <label>Arranged By</label>
                                    <select
                                        name="arrangedBy"
                                        className="w-full"
                                        value={this.state.filterDetails.arrangedBy}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "arrangedBy",
                                                "filterDetails"
                                            )
                                        }
                                    >
                                        <option>Select</option>
                                        {this.state.arrangedByList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.arrangedBy}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                            <button className="add-btn" onClick={() => this.closeGridView()}
                            >
                                Add New
                            </button>

                        </div>
                        {/* 2. Item tabel  */}
                        <div className="itemList-table">
                            <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            {/* <td className='w-[10%]'>Sr. No</td> */}
                                            <td className='w-[20%]'>Order No</td>
                                            <td className='w-[20%]'>Date</td>
                                            <td className='w-[40%]'>Party Name</td>
                                            <td className='w-[20%] !text-center'>Action</td>
                                        </tr>
                                    </thead>

                                    {this.state.salesOrderEntryList && this.state.salesOrderEntryList.length > 0
                                        ? this.state.salesOrderEntryList.map((item, key) => (
                                            <tbody key={key}>
                                                <tr>
                                                    {/* <td>{key + 1}</td> */}
                                                    <td>{item.orderNo}</td>
                                                    <td>{moment(item.orderDate).format('DD MMM yyyy')}</td>
                                                    <td>{item.partyId.partyName}</td>
                                                    <td className='!text-center'>
                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.getAllOrderDetailsItemMappingById(item)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() => this.deleteSalesOrderById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ))
                                        : this.state.salesOrderEntryList &&
                                            this.state.salesOrderEntryList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.salesOrderEntryList &&
                                            this.state.salesOrderEntryList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}

                                </table>
                            </div>
                        </div>
                    </>
                ) : null}

                {/* Second page  */}
                {this.state.isGridView === false ? (
                    <>
                        <div className="salesEntry-scroll" style={{ maxHeight: "calc(100vh - 90px)", overflowY: "auto", paddingRight: "6px" }}>
                            {/* Product Details  */}
                            <div className="item-form mb-4">
                                <div className="flex items-center justify-between mb-2.5">
                                    <h2 className='text-black font-semibold text-start'>Party Details </h2>
                                    <button
                                        className="add-btn"
                                        disabled={!this.state.orderDetails.salesOrderId || this.state.itemDetailsArray.length === 0 || this.state.isProformaLoading}
                                        onClick={() => this.generateProformaInvoice()}
                                        title="Generate a Proforma Invoice for advance payment (nothing is saved)"
                                    >
                                        {this.state.isProformaLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Proforma Invoice"}
                                    </button>
                                </div>
                                <div className="item-grp flex gap-2.5 ">
                                    <div className="input-grp min-w-[25%]">
                                        <label>Party Name</label>
                                        <MultiSelectDropdown
                                            drpIdentity="partyId"
                                            options={this.state.partyDropdownList}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={(selected) =>
                                                this.setFilterParameters(selected, "partyId")
                                            }
                                            allowSelectAll={false}
                                            value={this.state.partyDropdownList.filter(
                                                (party) =>
                                                    party.value === this.state.orderDetails.partyId
                                            )}
                                            isDisabled={!this.state.isMaterialDetailsHide}
                                        />
                                    </div>
                                    <div className="input-grp min-w-[15%]">
                                        <label>Order Date</label>
                                        <input
                                            type="date"
                                            id="orderDate"
                                            name="orderDate"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            value={this.state.orderDetails.orderDate}
                                            onChange={(event) =>
                                                this.handleChange(event, "orderDate", "orderDetails")
                                            }
                                            disabled={!this.state.isMaterialDetailsHide}
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Remarks</label>
                                        <input
                                            type="text"
                                            id="remarks"
                                            name="remarks"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            value={this.state.orderDetails.remarks}
                                            onChange={(event) =>
                                                this.handleChange(
                                                    event,
                                                    "remarks",
                                                    "orderDetails"
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr />
                            {/* Item Details  */}
                            <div className="item-form mb-4 mt-2.5">
                                <h2 className='text-black font-semibold text-start mb-2.5'>Item Details </h2>
                                <div className="item-grp grid grid-cols-8 gap-2.5 mb-3 items-end">
                                    <div className="input-grp col-span-2">
                                        <label>Item Name</label>
                                        <MultiSelectDropdown
                                            drpIdentity="itemId"
                                            options={this.state.itemDropdownList}
                                            className={` ${this.state.validStateItemDetailsFields?.error?.itemId ? "errorInput" : ""}`}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={(selected) =>
                                                this.setFilterParameters(selected, "itemId", 'ItemDetails')
                                            }
                                            allowSelectAll={false}
                                            value={this.state.itemDropdownList.filter(
                                                (item) =>
                                                    item.value === this.state.itemDetails.itemId
                                            )}
                                            isDisabled={this.state.isMaterialDetailsHide}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>HSN / GST</label>
                                        <MultiSelectDropdown
                                            drpIdentity="hsnCodeId"
                                            options={this.state.hsnCodeList}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={(selected) =>
                                                this.setFilterParameters(selected, "hsnCodeId", 'ItemDetails')
                                            }
                                            allowSelectAll={false}
                                            value={this.state.hsnCodeList.filter(
                                                (h) => h.value === this.state.itemDetails.hsnCodeId
                                            )}
                                            isDisabled={this.state.isMaterialDetailsHide}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Quantity</label>
                                        <input
                                            type="number"
                                            id="quantity"
                                            name="quantity"
                                            className={`inputFocus ${this.state.validStateItemDetailsFields?.error?.quantity ? "errorInput" : ""}`}
                                            disabled={this.state.isMaterialDetailsHide}
                                            autocomplete="off"
                                            value={this.state.itemDetails.quantity}
                                            onChange={(event) =>
                                                this.handleChange(event, "quantity", "ItemDetails")
                                            }
                                        />
                                        {/* <ValidationText
                                        error={this.state.validStateItemDetailsFields.error.quantity}
                                    /> */}
                                    </div>

                                    <div className="input-grp w-full">
                                        <label>Free</label>
                                        <input
                                            type="number"
                                            id="free"
                                            name="free"
                                            className="inputFocus w-full"
                                            disabled={this.state.isMaterialDetailsHide}
                                            autocomplete="off"
                                            value={this.state.itemDetails.free}
                                            onChange={(event) =>
                                                this.handleChange(event, "free", "ItemDetails")
                                            }
                                        />

                                    </div>

                                    <div className="input-grp w-full">
                                        <label>MRP</label>
                                        <input
                                            type="number"
                                            id="mrp"
                                            name="mrp"
                                            className={`inputFocus ${this.state.validStateItemDetailsFields?.error?.mrp ? "errorInput" : ""}`}
                                            autocomplete="off"
                                            disabled={this.state.isMaterialDetailsHide}
                                            value={this.state.itemDetails.mrp}
                                            onChange={(event) =>
                                                this.handleChange(
                                                    event,
                                                    "mrp",
                                                    "ItemDetails"
                                                )
                                            }
                                        />
                                        {/* <ValidationText
                                        error={this.state.validStateItemDetailsFields.error.mrp}
                                    /> */}
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Rate</label>
                                        <input
                                            type="number"
                                            id="rate"
                                            name="rate"
                                            className={`inputFocus ${this.state.validStateItemDetailsFields?.error?.rate ? "errorInput" : ""}`}
                                            autocomplete="off"
                                            disabled={this.state.isMaterialDetailsHide}
                                            value={this.state.itemDetails.rate}
                                            onChange={(event) =>
                                                this.handleChange(
                                                    event,
                                                    "rate",
                                                    "ItemDetails"
                                                )
                                            }
                                        />
                                        {/* <ValidationText
                                        error={this.state.validStateItemDetailsFields.error.rate}
                                    /> */}
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            disabled
                                            value={this.state.itemDetails.amount}
                                            onChange={(event) =>
                                                this.handleChange(
                                                    event,
                                                    "amount",
                                                    "ItemDetails"
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="btn-grp">
                                    {this.state.isEditing === true ? (
                                        <button
                                            className="add-btn"
                                            disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                                            onClick={() => this.addEditSalesOrderEntry()}
                                        >
                                            {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                        </button>
                                    ) : (
                                        <button
                                            className="add-btn"
                                            disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                                            onClick={() => this.addEditSalesOrderEntry()}
                                        >
                                            {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                                        </button>
                                    )}
                                    <button className='cancel-btn' onClick={this.openGridView}>Cancel</button>
                                </div>
                            </div>
                            {/* Item Table  */}
                            <div className="itemList-table">
                                <div className="table-container" style={{ minHeight: "160px", maxHeight: "280px", overflowY: "auto" }}>
                                    <table className="itemList ">
                                        <thead>
                                            <tr>
                                                <td className='w-[4%]'>Sr.</td>
                                                <td className='w-[20%]'>Item Name</td>
                                                <td className='w-[9%]'>HSN</td>
                                                <td className='w-[8%]'>Quantity</td>
                                                <td className='w-[7%]'>Free</td>
                                                <td className='w-[8%]'>MRP</td>
                                                <td className='w-[9%]'>Rate</td>
                                                <td className='w-[10%]'>Taxable</td>
                                                <td className='w-[9%]'>GST</td>
                                                <td className='w-[9%]'>Amount</td>
                                                <td className='w-[10%] !text-center'>Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.computedItemListing && this.state.computedItemListing.length > 0
                                                ? this.state.computedItemListing.map((item, key) => (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{item.itemId.ItemName}</td>
                                                        <td>{item.hsnCode || '-'}</td>
                                                        <td>{Number(item.quantity).toFixed(2)}</td>
                                                        <td>{item.free}</td>
                                                        <td>{item.mrp}</td>
                                                        <td>{Number(item.rate).toFixed(2)}</td>
                                                        <td>{Number(item.taxable).toFixed(2)}</td>
                                                        <td>{Number(item.gstAmount).toFixed(2)} ({item.gstRate}%)</td>
                                                        <td>{item.amount}</td>
                                                        <td className='!text-center'>
                                                            <button
                                                                className="search-btn"
                                                                onClick={() => this.editItemDetails(item)}
                                                            >
                                                                <FontAwesomeIcon icon={faPen} />
                                                            </button>

                                                            <button
                                                                className="cancel-btn"
                                                                onClick={() => this.deleteSalesOrderItemByItemId(item._id)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                                : (
                                                    <tr>
                                                        <td colSpan={11} style={{ textAlign: "center", color: "#999", fontSize: "14px", padding: "40px 0" }}>
                                                            No items added yet — added items will appear here.
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                            {/* Proforma details (charges) + GST breakup + Amounts summary */}
                            <div className="item-form mt-4">
                                <h2 className='text-black font-semibold text-start mb-2.5'>Proforma Details (for advance payment)</h2>
                                <div className="item-grp grid grid-cols-3 gap-2.5 mb-3">
                                    <div className="input-grp">
                                        <label>Transport Name</label>
                                        <input type="text" className="inputFocus w-full" autoComplete="off"
                                            value={this.state.proformaDetails.transportName}
                                            onChange={(event) => this.handleProformaChange(event, "transportName")}
                                            onBlur={() => this.saveProformaDetails()} />
                                    </div>
                                    <div className="input-grp">
                                        <label>Delivery Date</label>
                                        <input type="date" className="inputFocus w-full" autoComplete="off"
                                            value={this.state.proformaDetails.deliveryDate}
                                            onChange={(event) => this.handleProformaChange(event, "deliveryDate")}
                                            onBlur={() => this.saveProformaDetails()} />
                                    </div>
                                    <div className="input-grp">
                                        <label>Due Date</label>
                                        <input type="date" className="inputFocus w-full" autoComplete="off"
                                            value={this.state.proformaDetails.dueDate}
                                            onChange={(event) => this.handleProformaChange(event, "dueDate")}
                                            onBlur={() => this.saveProformaDetails()} />
                                    </div>
                                    <div className="input-grp">
                                        <label>Freight</label>
                                        <input type="number" className="inputFocus w-full" autoComplete="off"
                                            value={this.state.proformaDetails.freight}
                                            onChange={(event) => this.handleProformaChange(event, "freight")}
                                            onBlur={() => this.saveProformaDetails()} />
                                    </div>
                                    <div className="input-grp">
                                        <label>Discount</label>
                                        <input type="number" className="inputFocus w-full" autoComplete="off"
                                            value={this.state.proformaDetails.discount}
                                            onChange={(event) => this.handleProformaChange(event, "discount")}
                                            onBlur={() => this.saveProformaDetails()} />
                                    </div>
                                    <div className="input-grp">
                                        <label>Advance</label>
                                        <input type="number" className="inputFocus w-full" autoComplete="off"
                                            value={this.state.proformaDetails.advance}
                                            onChange={(event) => this.handleProformaChange(event, "advance")}
                                            onBlur={() => this.saveProformaDetails()} />
                                    </div>
                                </div>
                                <div className="flex gap-4 items-start flex-wrap">
                                    <div className="flex-1 min-w-[420px]">
                                        <HSNCodeTable hsnCodeListForTable={this.state.hsnCodeListForTable} />
                                    </div>
                                    <div className="item-sections min-w-[280px] max-w-[320px] p-3 rounded-[10px]"
                                        style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "rgb(245 245 245)" }}>
                                        <p className='text-center font-semibold mb-1'>Amounts</p>
                                        {[
                                            { label: 'Sub Total', value: this.state.proformaTotals.subTotalInclGst },
                                            { label: 'SGST', value: this.state.proformaTotals.sgst },
                                            { label: 'CGST', value: this.state.proformaTotals.cgst },
                                            { label: 'IGST', value: this.state.proformaTotals.igst },
                                            { label: 'Freight', value: this.state.proformaTotals.freightInclGst },
                                            { label: 'Round Off', value: this.state.proformaTotals.roundOff },
                                        ].map((row, i) => (
                                            <div key={i} className="flex justify-between text-[14px] text-[#585858] py-[3px]">
                                                <span>{row.label}</span>
                                                <span>{Number(row.value).toFixed(2)}</span>
                                            </div>
                                        ))}
                                        <div className="flex justify-between text-[15px] font-semibold py-[4px] border-t mt-1">
                                            <span>Grand Total</span>
                                            <span>{Number(this.state.proformaTotals.grandTotal).toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between text-[14px] text-[#585858] py-[3px]">
                                            <span>Advance</span>
                                            <span>{Number(this.state.proformaTotals.advance).toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between text-[15px] font-semibold py-[4px] border-t">
                                            <span>Balance</span>
                                            <span>{Number(this.state.proformaTotals.balance).toFixed(2)}</span>
                                        </div>
                                        <button
                                            className="add-btn w-full mt-3"
                                            disabled={!this.state.orderDetails.salesOrderId || this.state.itemDetailsArray.length === 0 || this.state.isProformaLoading}
                                            onClick={() => this.generateProformaInvoice()}
                                        >
                                            {this.state.isProformaLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Generate Proforma Invoice"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                ) : null}
            </div>
        )
    }
}
export default SalesOrderEntry;